/*
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * AppDispatcher
 *
 * A singleton that operates as the central hub for application updates.
 */
import { isDev, logDispatch } from '../utils/env';

var Flux = require('flux');
var Dispatcher = Flux.Dispatcher;

const dispatcher = new Dispatcher();

const originalDispatch = dispatcher.dispatch;
if (isDev()) {
	dispatcher.dispatch = function (payload) {
		logDispatch(payload);
		originalDispatch.call(this, payload);
	};
}

dispatcher.dispatchAsync = (...args) => setTimeout(() => dispatcher.dispatch(...args));

module.exports = dispatcher;
